import { render, staticRenderFns } from "./charge-goods-cost.vue?vue&type=template&id=440a3ddf&scoped=true"
import script from "./charge-goods-cost.vue?vue&type=script&lang=js"
export * from "./charge-goods-cost.vue?vue&type=script&lang=js"
import style0 from "./charge-goods-cost.vue?vue&type=style&index=0&id=440a3ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a3ddf",
  null
  
)

export default component.exports